import React from "react";

const LoaderPublicAbilities = ({ cardCount = 11 }) => {
    return (
        Array.from({ length: cardCount }).map((_, index) => (
            <div key={index} className="directories_loader_item fade-in" />
        ))
    );
};

export default LoaderPublicAbilities;